/* eslint-disable react/jsx-props-no-spreading */
import { Row, Col, Spin } from 'antd';
import React from 'react';

import { Button, Typography } from '@atoms';
import { useModalControls } from '@hooks';
import { FULL_WIDTH } from '@constants';
import { useMedia } from '@api/hooks';
import { MEDIA_TYPE } from '@api/media/constants';
import { getSrc } from '@utils/media';
import AddMediaModal from '@organisms/AddMediaModal';

const DocumentSelect = ({ value, onChange, disabled, buttonText = 'CHOOSE A NEW DOCUMENT', rowProps }) => {
  const modal = useModalControls();

  const { data: media, error, ...mediaQuery } = useMedia({ id: value });
  const title = error ? 'Error loading document' : media?.title || 'No document';

  return (
    <>
      <Spin spinning={mediaQuery.isFetching}>
        <Row align="middle" justify="flex-start" gutter={20} {...rowProps}>
          <Col>
            <Button disabled={disabled} onClick={modal.show}>
              {buttonText}
            </Button>
          </Col>
          <Col>
            <a href={getSrc({ media })} target="_blank" rel="noopener noreferrer">
              <Typography.Text ellipsis style={FULL_WIDTH}>
                {title}
              </Typography.Text>
            </a>
          </Col>
        </Row>
      </Spin>
      <AddMediaModal {...modal} initialMedia={media} onAddMedia={({ id }) => onChange(id)} type={MEDIA_TYPE.DOCUMENT} />
    </>
  );
};

export default DocumentSelect;
